var map = {
	"./swiper_1.png": "8abd",
	"./swiper_2.png": "e6a6",
	"./swiper_3.png": "6f1f",
	"./swiper_4.png": "adba",
	"./swiper_5.png": "43a5",
	"./swiper_6.png": "66a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ab8";